import { JournalInfo, TradeItem } from 'core/types'
import { ReactNode, useContext, useMemo } from 'react'
import Table from 'shared/Table'
import { TradesTableTabContext } from '../../TradesTableTabContext'
import { AllowedTradeKeys } from '../../TradesTableTabContext/models'
import { TRADES_TABLE_CELLS_RENDER_MAP } from './cells/cells-render-map'
import { MenuCell } from './cells/MenuCell'
import { useSelectedJournalIsLocked } from '../../hooks'
import { useRecoilState } from 'recoil'
import { filterState } from 'core/store'

type TradesTableDynamicRowProps = {
  item: TradeItem
  journalsIdMap: Record<string, JournalInfo>
  onClick: () => void
}
export function TradesTableDynamicRow({
  item,
  journalsIdMap,
  onClick,
}: Readonly<TradesTableDynamicRowProps>) {
  const [filters] = useRecoilState(filterState)
  const { columns } = useContext(TradesTableTabContext)
  const selectedJournalIsLocked = useSelectedJournalIsLocked()
  console.log('selectedJournalIsLocked', selectedJournalIsLocked)

  const finalCells: ReactNode = useMemo(() => {
    return columns.map((tableHeader, idx) => {
      const key = tableHeader.sortableKey as AllowedTradeKeys
      const func = TRADES_TABLE_CELLS_RENDER_MAP[key]
      return func(item[key] as never, idx + 'key')
    })
  }, [columns, item])

  return (
    <Table.Row onClick={onClick}>
      {filters.journalId === null && (
        <Table.Cell className="no-wrap">
          {journalsIdMap[item.journalId]?.journalName ?? '-'}
        </Table.Cell>
      )}

      {finalCells}

      <NoteCell noteItem={item.note} />
      {!selectedJournalIsLocked && <MenuCell item={item} />}
    </Table.Row>
  )
}

type NoteCellProps = { noteItem: TradeItem['note'] }
function NoteCell({ noteItem }: Readonly<NoteCellProps>) {
  return (
    <Table.Cell className="NoteCell">
      {noteItem == null || noteItem.noteText === '' ? (
        <div className="text empty"> - </div>
      ) : (
        <abbr title={noteItem.noteText} className="text">
          {noteItem.noteText}
        </abbr>
      )}
    </Table.Cell>
  )
}
